import { toast } from "react-toastify";
import baseURL from "../components/authComponents/baseURL/BaseURL";
import loginToken from "../components/authComponents/localStorageItems/LoginTokin";

/**
 * Fetches the compatibility questionnaire from the API and opens the
 * full-screen overlay experience via a custom window event.
 *
 * The overlay component (CompatibilityTestOverlay) listens for
 * "openCompatibilityTest" events and renders the journey.
 */
export const handleCompatibilityTest = async () => {
  try {
    const response = await baseURL.get("/api/v1/match_making_questioners", {
      headers: { Authorization: `Bearer ${loginToken}` },
    });

    const questionnaire = response.data.questionnaire;
    const userAnswers = response.data.user_answers || {};

    if (!questionnaire || Object.keys(questionnaire).length === 0) {
      toast.info("No questions available at the moment.");
      return;
    }

    // Dispatch event to the overlay component
    window.dispatchEvent(
      new CustomEvent("openCompatibilityTest", {
        detail: { questionnaire, userAnswers },
      })
    );
  } catch (error) {
    console.error("Fetch questionnaire error:", error);
    toast.error("Failed to load questionnaire. Please try again later.");
  }
};
